import Vue from 'vue';
import App from './App.vue';
import './styles/output.css';
import './styles/style.css';
import Artists from './components/artists.vue';
import Genres from './components/genres.vue';
import Artist from './components/artist.vue';
import Album from './components/album.vue';
import Song from './components/song.vue';
// import SearchPage from './components/searchPage.vue';
import Search from './components/search.vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{ path: '/', component: Search },
		{ path: '/artists', component: Artists },
		{ path: '/genres', component: Genres },
		{ path: '/artist/:id', component: Artist },
		{ path: '/album', component: Album },
		{ path: '/song/:id', component: Song }
	]
});

Vue.config.productionTip = false;

new Vue({
	el: '#app',
	render: h => h(App),
	router
});
